import {
    useDispatch,
    useSelector,
} from 'react-redux'
import type {
    TypedUseSelectorHook,
} from 'react-redux'
import type {
    AppDispatch,
    RootState,
} from '../store'

/**
 * Typed dispatch hook bound to the application store.
 */
export const useAppDispatch: () => AppDispatch = useDispatch

/**
 * Typed selector hook bound to the application root state.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
